import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { AlertasComponent } from '../alertas/alertas.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  public viewUser:boolean=false;
  public viewPass:boolean=false;
  loginForm: FormGroup;
  //private activatedRoute: ActivatedRoute
  constructor(private route: ActivatedRoute,private router:Router,public dialog: MatDialog,public global: GlobalService, private loadingScreenService: LoadingScreenService, private formBuilder: FormBuilder, public appComponent: AppComponent, private services: Service,public AngularFireAnalytics:AngularFireAnalytics) {
    this.createForm();
  //  this.AngularFireAnalytics.setCurrentScreen("Autenticación");
  //  this.AngularFireAnalytics.logEvent("Autenticación-Screenview");
  }
  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: false
    });
  }
  ngOnInit() {
    this.global.signOff();
    this.route.queryParams.subscribe(params => {
      if (params && params.token) {
        this.loginExternal(params.token);
      }
    });
    /*
    if(this.route.snapshot.paramMap.get('token')!=null){
      let token=this.route.snapshot.paramMap.get('token');
      this.loginExternal(token);
    }
    */

    let rememberUser = sessionStorage.getItem('rememberUser');
    console.log(rememberUser);

    this.loginForm.get('remember').setValue(rememberUser !== null);
    this.loginForm.get('username').setValue(rememberUser !== null ? rememberUser : '');
  }
  getIn(event){
    if(event.key){
      if(event.key=="Enter"){
        this.login();
      }
      else{
        this.global.validateInputKey(event);
      }
    }
    else{
      this.global.validateInputKey(event);
    }
  }
  clean() {
    this.loginForm.reset({ username: '', password: '' });
  }
  login() {
    let username: string = (this.loginForm.value.username).trim();
    let password: string = this.loginForm.value.password;
    let idUser: string;
    let objAccounts;
    let userName2: string;
    let name2: any;
    let companyName2: any;
    if (!this.loginForm.invalid) {
      this.loadingScreenService.startLoading();
      this.services.login(btoa(username), btoa(password)).subscribe(data => {
        if (data.hasError === false) {
          objAccounts = data.accounts;
          idUser = objAccounts.AccountList[0].userID;

          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("idUser", idUser);

          var requiredEmailUpdate = data.requiredEmailUpdate;
          var requiredPaperless = data.requiredPaperless;
          var requiredQuestions = data.requiredQuestions;
          sessionStorage.setItem("selectBan", btoa(data.account));
          sessionStorage.setItem("email", btoa(data.email));
          sessionStorage.setItem("logState", btoa(JSON.stringify(false)));
          if (data.requiredPasswordReset == true) {
            this.global.requiredPasswordReset = true;
            this.loadingScreenService.stopLoading();
            this.router.navigate(['forgotpassword']);
          }
          else {
            if (data.username.length > 18) {
              userName2 = data.username.toString().substring(0, 18) + "...";
              sessionStorage.setItem("userName", userName2);
            }
            else {
              sessionStorage.setItem("userName", data.username);
            }
            if (data.name.length > 18) {
              name2 = data.name.toString().substring(0, 18) + "...";
              sessionStorage.setItem("name", name2);
            }
            else {
              sessionStorage.setItem("name", data.name);
            }
            sessionStorage.setItem("userName2", btoa(JSON.stringify(data.username)));
            sessionStorage.setItem("defaultSubscriber", btoa(data.subscriber));
            sessionStorage.setItem("requiredAccountUpdate", btoa(JSON.stringify(data.requiredAccountUpdate)));

            let accountName;
            let lastName: string = '';
            let name: string = '';
            if (data.name != "") {
              accountName = data.name.split(" ");
              name = accountName[0] + ' ' + accountName[1];
              for (let i = 0; i < accountName.length; i++) {
                if (i > 1) {
                  lastName = lastName + ' ' + accountName[i];
                }
              }
              lastName = lastName.trim();
            }
            this.services.permissions(data.token, data.accountType, name, lastName).subscribe(dataPermission => {
              if (dataPermission.hasError == false) {
                sessionStorage.setItem("idParent", dataPermission.idParent);
                sessionStorage.setItem("idUserAPP", dataPermission.idUserAPP);
                sessionStorage.setItem("AccountList", btoa(JSON.stringify(objAccounts.AccountList)));
                sessionStorage.setItem("moduleData", btoa(JSON.stringify(dataPermission.permission)));
                this.services.accountDetails(data.token, btoa(data.subscriber), btoa(data.account)).subscribe(data2 => {
                  if (data2.HasError == false) {
                    sessionStorage.setItem("getAcoout", btoa(JSON.stringify(data)));
                    sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
                    this.services.getPersonalData(data.token, data.account).subscribe(data => {
                      if (data.HasError == false || data.HasError == true) {
                        this.loadingScreenService.stopLoading();
                        sessionStorage.setItem("GetPersonalData", btoa(JSON.stringify(data)));
                        var companyName = data.BusinessName;
                        if (companyName == null || companyName == '' || companyName == undefined) {
                          var accountData = JSON.parse(atob(sessionStorage.getItem("GetPersonalData")));
                          var fullName = accountData.FirstName + ' ' + accountData.LastName + ' ' + accountData.LastSecondName;
                          companyName = fullName;
                        }
                        sessionStorage.setItem("companyName", btoa(companyName));
                        this.global.session();
                        sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(false)));

                        if (this.loginForm.value.remember) {
                          sessionStorage.setItem('rememberUser', username);
                        } else {
                          sessionStorage.removeItem('rememberUser');
                        }

                        if (requiredPaperless === true) {
                          this.router.navigate(['home']);
                        } else if (requiredQuestions === true) {
                          sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(true)));
                          this.router.navigate(['home']);
                        } else if (requiredEmailUpdate === true) {
                          this.router.navigate(['profile/2']);
                        }
                        else {
                          this.router.navigate(['home']);
                        }
                      }
                      else {
                        this.global.notif(data.ErrorDesc);
                        this.loadingScreenService.stopLoading();
                      }
                    });
                  }
                  else {
                    this.global.notif(data2.errorDisplay);
                  }
                });
              }
              else {
                this.loadingScreenService.stopLoading();
                this.global.notif(dataPermission.errorDesc);
              }
            });
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          if (data.errorNum === 32) {
            this.global.notif(data.errorDisplay+" Su usuario se encuentra bloqueado para desbloquearlo debe recuperar su contraseña.");
            // let username2 = username;
            // let menssageError = data.errorDisplay;
            // const dialogConfig = new MatDialogConfig();
            // dialogConfig.disableClose = true;
            // dialogConfig.autoFocus = true;
            // dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, Gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', btmConfirm: true };
            // const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
            // dialogRef.afterClosed().subscribe(value => {
            //   if (value == 'continue') {
            //     let url = this.global.pathChat + '?Email=' + username2 + '&firstname=' + username2 + '&lastname=' + username2 + '&Question=' + 'Problema para iniciar sesión.' + '&Department=' + '16' + '';
            //     window.open(url, '', 'width=630, height=490,top=100,left=100');
            //   }
            // });
          }
          else if(data.errorNum === 41){ //data.errorNum === 0 es cableado, 41 no es cableado
            this.loadingScreenService.stopLoading();
            this.global.notif("Hemos detectado un problema con su acceso. Favor comunicarse con asistencia al cliente. Puede enviar un correo electrónico electronico a wholesalegroup@claropr.com o llamar al 787-273-9999.");
            //this.router.navigate(['loginupdate']);
            //sessionStorage.setItem("token", data.token);
          }
          else {
            this.global.notif(data.errorDisplay);
          }
        }
      });
    }
  }
  loginExternal(token) {
    let idUser: string;
    let objAccounts;
    let userName2: string;
    let name2: any;
    let companyName2: any;
    if (token) {
      this.loadingScreenService.startLoading();
      this.services.loginExternal(token).subscribe(data => {
        if (data.hasError === false) {
          objAccounts = data.accounts;
          idUser = objAccounts.AccountList[0].userID;

          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("idUser", idUser);

          var requiredEmailUpdate = data.requiredEmailUpdate;
          var requiredPaperless = data.requiredPaperless;
          var requiredQuestions = data.requiredQuestions;
          sessionStorage.setItem("selectBan", btoa(data.account));
          sessionStorage.setItem("email", btoa(data.email));
          sessionStorage.setItem("logState", btoa(JSON.stringify(false)));
          if (data.requiredPasswordReset == true) {
            this.global.requiredPasswordReset = true;
            this.loadingScreenService.stopLoading();
            this.router.navigate(['forgotpassword']);
          }
          else {
            if (data.username.length > 18) {
              userName2 = data.username.toString().substring(0, 18) + "...";
              sessionStorage.setItem("userName", userName2);
            }
            else {
              sessionStorage.setItem("userName", data.username);
            }
            if (data.name.length > 18) {
              name2 = data.name.toString().substring(0, 18) + "...";
              sessionStorage.setItem("name", name2);
            }
            else {
              sessionStorage.setItem("name", data.name);
            }
            sessionStorage.setItem("userName2", btoa(JSON.stringify(data.username)));
            sessionStorage.setItem("defaultSubscriber", btoa(data.subscriber));
            sessionStorage.setItem("requiredAccountUpdate", btoa(JSON.stringify(data.requiredAccountUpdate)));

            let accountName;
            let lastName: string = '';
            let name: string = '';
            if (data.name != "") {
              accountName = data.name.split(" ");
              name = accountName[0] + ' ' + accountName[1];
              for (let i = 0; i < accountName.length; i++) {
                if (i > 1) {
                  lastName = lastName + ' ' + accountName[i];
                }
              }
              lastName = lastName.trim();
            }
            this.services.permissions(data.token, data.accountType, name, lastName).subscribe(dataPermission => {
              if (dataPermission.hasError == false) {
                sessionStorage.setItem("idParent", dataPermission.idParent);
                sessionStorage.setItem("idUserAPP", dataPermission.idUserAPP);
                sessionStorage.setItem("AccountList", btoa(JSON.stringify(objAccounts.AccountList)));
                sessionStorage.setItem("moduleData", btoa(JSON.stringify(dataPermission.permission)));
                this.services.accountDetails(data.token, btoa(data.subscriber), btoa(data.account)).subscribe(data2 => {
                  if (data2.HasError == false) {
                    sessionStorage.setItem("getAcoout", btoa(JSON.stringify(data)));
                    sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
                    this.services.getPersonalData(data.token, data.account).subscribe(data => {
                      if (data.HasError == false || data.HasError == true) {
                        this.loadingScreenService.stopLoading();
                        sessionStorage.setItem("GetPersonalData", btoa(JSON.stringify(data)));
                        var companyName = data.BusinessName;
                        if (companyName == null || companyName == '' || companyName == undefined) {
                          var accountData = JSON.parse(atob(sessionStorage.getItem("GetPersonalData")));
                          var fullName = accountData.FirstName + ' ' + accountData.LastName + ' ' + accountData.LastSecondName;
                          companyName = fullName;
                        }
                        sessionStorage.setItem("companyName", btoa(companyName));
                        this.global.session();
                        sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(false)));
                        if (requiredPaperless === true) {
                          this.router.navigate(['home']);
                        } else if (requiredQuestions === true) {
                          sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(true)));
                          this.router.navigate(['home']);
                        } else if (requiredEmailUpdate === true) {
                          this.router.navigate(['profile/2']);
                        }
                        else {
                          this.router.navigate(['home']);
                        }
                      }
                      else {
                        this.global.notif(data.ErrorDesc);
                        this.loadingScreenService.stopLoading();
                      }
                    });
                  }
                  else {
                    this.global.notif(data2.errorDisplay);
                  }
                });
              }
              else {
                this.loadingScreenService.stopLoading();
                this.global.notif(dataPermission.errorDesc);
              }
            });
          }
        }
        else {
          if (data.errorNum === 32 || data.errorNum === 33 || data.errorNum === 31 || data.errorNum === 30) {
            this.loadingScreenService.stopLoading();
            let username2 = "Por token";
            let menssageError = data.errorDisplay;
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.data = { inverse: true, colorSi: 'colorRed', colorNo: 'colorGray', labelSi: 'Conectar vía Chat', labelNo: 'No, Gracias', menssageError: menssageError, messageHtml: false, labelTitleHtml: 'Bienvenido a Mi Claro Asistencia', message: '', btmConfirm: true };
            const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(value => {
              if (value == 'continue') {
                let url = this.global.pathChat + '?Email=' + username2 + '&firstname=' + username2 + '&lastname=' + username2 + '&Question=' + 'Problema para iniciar sesión.' + '&Department=' + '16' + '';
                window.open(url, '', 'width=630, height=490,top=100,left=100');
              }
            });
          }
          else if(data.errorNum === 41){ //data.errorNum === 0 es cableado, 41 no es cableado
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
            this.router.navigate(['loginupdate']);
            sessionStorage.setItem("token", data.token);
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
          }
        }
      });
    }
  }



  onBlur(origin:number){

  }

  validateForms(bool:boolean,origin:number){
    if(origin==1){
      let user:string=String(this.loginForm.controls.username.value);
      if(((user.trim()).length==0)&&bool==false){
        this.viewUser=false;
      }
      else{
        this.viewUser=true;
      }
    }
    if(origin==2){
      let pass:string=String(this.loginForm.controls.password.value);
      if(((pass.trim()).length==0)&&bool==false){
        this.viewPass=false;
      }
      else{
        this.viewPass=true;
      }
    }
  }


  changeRememberMe() {
    if (this.loginForm.value.remember) {
      sessionStorage.removeItem('rememberUser');
    }
  }
}
